import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { HomeComponent } from './components/home/home.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { NewProjectComponent } from './components/projects/new-project/new-project.component';
import { ParticipantsComponent } from './components/participants/participants.component';
import { NewParticipantComponent } from './components/participants/new-participant/new-participant.component';
import { ViewProjectComponent } from './components/projects/view-project/view-project.component';
import { ConfigBudgetsComponent } from './components/config/config-budgets/config-budgets.component';
import { ThirdPartiesComponent } from './components/third-parties/third-parties.component';
import { NewThirdPartieComponent } from './components/third-parties/new-third-partie/new-third-partie.component';
import { WorkOrdersComponent } from './components/work-orders/work-orders.component';
import { NewWorkOrderComponent } from './components/work-orders/new-work-order/new-work-order.component';
import { NewExpenseReceiptComponent } from './components/expense-receipts/new-expense-receipt/new-expense-receipt.component';
import { ExpenseReceiptsComponent } from './components/expense-receipts/expense-receipts.component';
import { ViewWorkOrderComponent } from './components/work-orders/view-work-order/view-work-order.component';
import { ViewExpenseReceiptComponent } from './components/expense-receipts/view-expense-receipt/view-expense-receipt.component';
import { LoginComponent } from './components/login/login.component';
import { EnrollmentsComponent } from './components/enrollments/enrollments.component';
import { NewEnrollmentComponent } from './components/enrollments/new-enrollment/new-enrollment.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { NewCompanyComponent } from './components/companies/new-company/new-company.component';
import { ProfileCompanyComponent } from './components/companies/profile-company/profile-company.component';
import { ViewEnrollmentComponent } from './components/enrollments/view-enrollment/view-enrollment.component';
import { ViewEnrollmentV2Component } from './components/enrollments/view-enrollment-v2/view-enrollment-v2.component';
import { ViewCorporateEnrollmentComponent } from './components/enrollments/view-corporate-enrollment/view-corporate-enrollment.component';
import { ViewCorporateEnrollmentV2Component } from './components/enrollments/view-corporate-enrollment-v2/view-corporate-enrollment-v2.component';
import { IncomeReceiptsComponent } from './components/income-receipts/income-receipts.component';
import { BusinessIncomeReceiptsComponent } from './components/income-receipts/business-income-receipts/business-income-receipts.component';
import { PendingApprovalsComponent } from './components/income-receipts/pending-approvals/pending-approvals.component';
import { NewIncomeReceiptComponent } from './components/income-receipts/new-income-receipt/new-income-receipt.component';
import { ViewIncomeReceiptComponent } from './components/income-receipts/view-income-receipt/view-income-receipt.component';
import { ProfileParticipantComponent } from './components/participants/profile-participant/profile-participant.component';
import { ProfileThirdPartyComponent } from './components/third-parties/profile-third-party/profile-third-party.component';
import { EditPaymentPlansComponent } from './components/enrollments/edit-payment-plans/edit-payment-plans.component';
import { EditCorporateCompanyPlansComponent } from './components/enrollments/edit-corporate-company-plans/edit-corporate-company-plans.component';
import { EditCorporateParticipantPlansComponent } from './components/enrollments/edit-corporate-participant-plans/edit-corporate-participant-plans.component';
import { PaymentPlanAuditComponent } from './components/payment-plan-audit/payment-plan-audit.component';
import { PaymentPlanAuditBulkFixComponent } from './components/payment-plan-audit-bulk-fix/payment-plan-audit-bulk-fix.component';
import { EnrollmentStatusAuditComponent } from './components/enrollment-status-audit/enrollment-status-audit.component';
import { EnrollmentAuditBulkFixComponent } from './components/enrollment-audit-bulk-fix/enrollment-audit-bulk-fix.component';
import { ProjectDeletionProgressComponent } from './components/projects/project-deletion-progress/project-deletion-progress.component';
import { ReportsHubComponent } from "./components/reports/reports-hub/reports-hub.component";
import { BanksReportsComponent } from "./components/reports/banks-reports/banks-reports.component";
import { IncomeReceiptsReportsComponent } from './components/reports/income-receipts-reports/income-receipts-reports.component';
import { ExpenseReceiptsReportsComponent } from './components/reports/expense-receipts-reports/expense-receipts-reports.component';
import { ProjectBudgetExecutionReportsComponent } from './components/reports/project-budget-execution-reports/project-budget-execution-reports.component';
import { BanksComponent } from "./components/config/banks/banks.component";
import { NewBankComponent } from "./components/config/banks/new-bank/new-bank.component";
import { SystemResetComponent } from './components/config/system-reset/system-reset.component';
import { PaymentMethodsComponent } from './components/config/payment-methods/payment-methods.component';
import { NewPaymentMethodComponent } from './components/config/payment-methods/new-payment-method/new-payment-method.component';
import { RefundVouchersComponent } from './components/refund-vouchers/refund-vouchers.component';
import { ViewRefundVoucherComponent } from './components/refund-vouchers/view-refund-voucher/view-refund-voucher.component';
import { NewRefundComponent } from './components/refund-vouchers/new-refund/new-refund.component';
import { ExcessPaymentsComponent } from './components/excess-payments/excess-payments.component';
import { ViewExcessPaymentComponent } from './components/excess-payments/view-excess-payment/view-excess-payment.component';
// 🆕 Imports para conciliaciones bancarias
import { BankReconciliationListComponent } from './components/bank-reconciliation/bank-reconciliation-list/bank-reconciliation-list.component';
import { NewBankReconciliationComponent } from './components/bank-reconciliation/new-bank-reconciliation/new-bank-reconciliation.component';
import { ClosedPeriodsListComponent } from './components/bank-closing/closed-periods-list/closed-periods-list.component';
import { WorkOrdersReportsComponent } from './components/reports/work-orders-reports/work-orders-reports.component';
import { ProjectProgramDetailReportsComponent } from './components/reports/project-program-detail-reports/project-program-detail-reports.component';
import { ExchangeRateConfigComponent } from './components/config/exchange-rate/exchange-rate-config.component';
import { ExchangeRateHistoryComponent } from './components/config/exchange-rate/exchange-rate-history.component';
import { FeeTypesComponent } from './components/config/fee-types/fee-types.component';
import { NewFeeTypeComponent } from './components/config/fee-types/new-fee-type/new-fee-type.component';
import { AuditLogsComponent } from './components/config/audit-logs/audit-logs.component';
import { EmailLogsComponent } from './components/config/email-logs/email-logs.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PortfolioReportsComponent } from "./components/reports/portfolio-reports/portfolio-reports.component";
import { CreatedProjectsReportsComponent } from './components/reports/created-projects-reports/created-projects-reports.component';
import { RegisteredDataReportsComponent } from './components/reports/registered-data-reports/registered-data-reports.component';
import { ParticipantsByIncpReportsComponent } from './components/reports/participants-by-incp-reports/participants-by-incp-reports.component';
import { ProjectFinancialStatementReportsComponent } from './components/reports/project-financial-statement-reports/project-financial-statement-reports.component';
import { ProjectEnrollmentsReportsComponent } from './components/reports/project-enrollments-reports/project-enrollments-reports.component';
import { BitrixRequestsComponent } from './components/bitrix-requests/bitrix-requests.component';
import { ViewBitrixRequestComponent } from './components/bitrix-requests/view-bitrix-request/view-bitrix-request.component';
import { WompiRequestsComponent } from './components/wompi-requests/wompi-requests.component';
import { ViewWompiRequestComponent } from './components/wompi-requests/view-wompi-request/view-wompi-request.component';
import { WompiRelayListComponent } from './components/config/wompi-relay/wompi-relay-list.component';
import { NewWompiRelayComponent } from './components/config/wompi-relay/new-wompi-relay/new-wompi-relay.component';
import { WompiRelayLogsComponent } from './components/config/wompi-relay/wompi-relay-logs/wompi-relay-logs.component';

// 🆕 Imports para gestión de roles y permisos
import { RolesListComponent } from './components/config/roles-permissions/roles-list/roles-list.component';
import { RoleFormComponent } from './components/config/roles-permissions/role-form/role-form.component';
import { UsersListComponent } from './components/config/roles-permissions/users-list/users-list.component';
import { PermissionGuard, SuperAdminGuard } from './guards/permission.guard';

// 🆕 Import para carga de reportes Wompi/Plink
import { ReportUploadComponent } from './components/report-upload/report-upload.component';
import { ConciliationConfigComponent } from './components/config/conciliation-config/conciliation-config.component';

// 🆕 Imports para gestión de cartera (Retiros, Reversiones, Aplazamientos)
import { WithdrawalWizardComponent } from './components/enrollments/withdrawal-wizard/withdrawal-wizard.component';
import { ReversalWizardComponent } from './components/enrollments/reversal-wizard/reversal-wizard.component';
import { DeferralWizardComponent } from './components/enrollments/deferral-wizard/deferral-wizard.component';
import { PunishedPortfolioReportComponent } from './components/reports/punished-portfolio-report/punished-portfolio-report.component';

// 🆕 Imports para gestión de cartera CORPORATIVA
import { PortfolioMovementsListComponent } from './components/enrollments/portfolio-movements-list/portfolio-movements-list.component';
import { CorporateWithdrawalWizardComponent } from './components/enrollments/corporate-withdrawal-wizard/corporate-withdrawal-wizard.component';
import { CorporateReversalWizardComponent } from './components/enrollments/corporate-reversal-wizard/corporate-reversal-wizard.component';
import { CorporateDeferralWizardComponent } from './components/enrollments/corporate-deferral-wizard/corporate-deferral-wizard.component';
import { AddCorporateParticipantsComponent } from './components/enrollments/add-corporate-participants/add-corporate-participants.component';

// 🆕 Import para Hub de Configuración
import { ConfigHubComponent } from './components/config/config-hub/config-hub.component';
import { UploadedReportsComponent } from './components/config/uploaded-reports/uploaded-reports.component';
import { ConciliationLogsComponent } from './components/config/conciliation-logs/conciliation-logs.component';
import { ConciliationLogDetailComponent } from './components/config/conciliation-logs/conciliation-log-detail/conciliation-log-detail.component';
import { ApproversComponent } from './components/config/approvers/approvers.component';

// 🆕 Imports para Notas Débito y Crédito
import { DebitNotesComponent } from './components/debit-notes/debit-notes.component';
import { NewDebitNoteComponent } from './components/debit-notes/new-debit-note/new-debit-note.component';
import { ViewDebitNoteComponent } from './components/debit-notes/view-debit-note/view-debit-note.component';
import { CreditNotesComponent } from './components/credit-notes/credit-notes.component';
import { NewCreditNoteComponent } from './components/credit-notes/new-credit-note/new-credit-note.component';
import { ViewCreditNoteComponent } from './components/credit-notes/view-credit-note/view-credit-note.component';

// 🆕 Imports para Cesiones de Cupo
import { EnrollmentTransfersComponent } from './components/enrollment-transfers/enrollment-transfers.component';
import { NewTransferComponent } from './components/enrollment-transfers/new-transfer/new-transfer.component';

// 🆕 Imports para visualización de Payment Links
import { PaymentLinksComponent } from './components/payment-links/payment-links.component';
import { ViewPaymentLinkComponent } from './components/payment-links/view-payment-link/view-payment-link.component';
import { WompiConsolidatedReportComponent } from './components/reports/wompi-consolidated-report/wompi-consolidated-report.component';
import { WompiPaymentsReportComponent } from './components/reports/wompi-payments-report/wompi-payments-report.component';
import { PaymentLinksAuditReportComponent } from './components/reports/payment-links-audit-report/payment-links-audit-report.component';
import { PaymentPlanHistoryComponent } from './components/enrollments/payment-plan-history/payment-plan-history.component';

// Bold Reports

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'prefix'
  },
  {
    path: 'dashboard',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, PermissionGuard],
    children: [
      // === DASHBOARD ===
      // El dashboard es accesible para todos los usuarios autenticados
      // El backend determina qué datos mostrar según permisos (BASIC o FULL)
      {
        path: '',
        component: HomeComponent
      },

      // === PROYECTOS ===
      {
        path: 'projects',
        component: ProjectsComponent,
        data: { permissions: ['PROJECTS_READ'] }
      },
      {
        path: 'projects/new-project',
        component: NewProjectComponent,
        data: { permissions: ['PROJECTS_CREATE'] }
      },
      {
        path: 'projects/view-project/:id',
        component: ViewProjectComponent,
        data: { permissions: ['PROJECTS_READ'] }
      },

      // === PARTICIPANTES/ESTUDIANTES ===
      {
        path: 'participants',
        component: ParticipantsComponent,
        data: { permissions: ['PARTICIPANTS_READ'] }
      },
      {
        path: 'participants/new-participant',
        component: NewParticipantComponent,
        data: { permissions: ['PARTICIPANTS_CREATE'] }
      },
      {
        path: 'participants/new-participant/:id',
        component: NewParticipantComponent,
        data: { permissions: ['PARTICIPANTS_UPDATE'] }
      },
      {
        path: 'participants/view-participant/:id',
        component: NewParticipantComponent,
        data: { permissions: ['PARTICIPANTS_READ'] }
      },
      {
        path: 'participants/profile-participant/:id',
        component: ProfileParticipantComponent,
        data: { permissions: ['PARTICIPANTS_READ'] }
      },

      // === PROVEEDORES/TERCEROS ===
      {
        path: 'third-parties',
        component: ThirdPartiesComponent,
        data: { permissions: ['SUPPLIERS_READ'] }
      },
      {
        path: 'third-partie/new',
        component: NewThirdPartieComponent,
        data: { permissions: ['SUPPLIERS_CREATE'] }
      },
      {
        path: 'third-partie/view/:id',
        component: NewThirdPartieComponent,
        data: { permissions: ['SUPPLIERS_READ'] }
      },
      {
        path: 'third-parties/profile-third-party/:id',
        component: ProfileThirdPartyComponent,
        data: { permissions: ['SUPPLIERS_READ'] }
      },

      // === ÓRDENES DE TRABAJO ===
      {
        path: 'work-orders',
        component: WorkOrdersComponent,
        data: { permissions: ['WORKORDERS_READ'] }
      },
      {
        path: 'work-orders/new',
        component: NewWorkOrderComponent,
        data: { permissions: ['WORKORDERS_CREATE'] }
      },
      {
        path: 'work-orders/view/:id',
        component: ViewWorkOrderComponent,
        data: { permissions: ['WORKORDERS_READ'] }
      },
      {
        path: 'work-orders/edit/:id',
        component: NewWorkOrderComponent,
        data: { permissions: ['WORKORDERS_UPDATE'] }
      },

      // === COMPROBANTES DE EGRESO ===
      {
        path: 'expense-receipts',
        component: ExpenseReceiptsComponent,
        data: { permissions: ['EXPENSE_READ'] }
      },
      {
        path: 'expense-receipts/new',
        component: NewExpenseReceiptComponent,
        data: { permissions: ['EXPENSE_CREATE'] }
      },
      {
        path: 'expense-receipts/view/:id',
        component: ViewExpenseReceiptComponent,
        data: { permissions: ['EXPENSE_READ'] }
      },

      // === COMPROBANTES DE INGRESO ===
      {
        path: 'income-receipts',
        redirectTo: 'income-receipts/individual',
        pathMatch: 'full'
      },
      {
        path: 'income-receipts/individual',
        component: IncomeReceiptsComponent,
        data: { permissions: ['INCOME_READ'] }
      },
      {
        path: 'income-receipts/business',
        component: BusinessIncomeReceiptsComponent,
        data: { permissions: ['INCOME_READ'] }
      },
      {
        path: 'income-receipts/pending-approvals',
        component: PendingApprovalsComponent,
        data: { permissions: ['INCOME_READ'] }
      },
      {
        path: 'income-receipts/new',
        component: NewIncomeReceiptComponent,
        data: { permissions: ['INCOME_CREATE'] }
      },
      {
        path: 'income-receipts/view/:id',
        component: ViewIncomeReceiptComponent,
        data: { permissions: ['INCOME_READ'] }
      },

      // === NOTAS DÉBITO ===
      {
        path: 'debit-notes',
        component: DebitNotesComponent,
        data: { permissions: ['EXPENSE_READ'] }
      },
      {
        path: 'debit-notes/new',
        component: NewDebitNoteComponent,
        data: { permissions: ['EXPENSE_CREATE'] }
      },
      {
        path: 'debit-notes/edit/:id',
        component: NewDebitNoteComponent,
        data: { permissions: ['EXPENSE_CREATE'] }
      },
      {
        path: 'debit-notes/view/:id',
        component: ViewDebitNoteComponent,
        data: { permissions: ['EXPENSE_READ'] }
      },

      // === NOTAS CRÉDITO ===
      {
        path: 'credit-notes',
        component: CreditNotesComponent,
        data: { permissions: ['INCOME_READ'] }
      },
      {
        path: 'credit-notes/new',
        component: NewCreditNoteComponent,
        data: { permissions: ['INCOME_CREATE'] }
      },
      {
        path: 'credit-notes/edit/:id',
        component: NewCreditNoteComponent,
        data: { permissions: ['INCOME_CREATE'] }
      },
      {
        path: 'credit-notes/view/:id',
        component: ViewCreditNoteComponent,
        data: { permissions: ['INCOME_READ'] }
      },

      // === INSCRIPCIONES ===
      {
        path: 'enrollments',
        redirectTo: 'enrollments/individual',
        pathMatch: 'full'
      },
      {
        path: 'enrollments/individual',
        component: EnrollmentsComponent,
        data: { permissions: ['ENROLLMENTS_READ'], view: 'individual' }
      },
      {
        path: 'enrollments/corporate',
        component: EnrollmentsComponent,
        data: { permissions: ['ENROLLMENTS_READ'], view: 'corporate' }
      },
      {
        path: 'enrollments/new',
        component: NewEnrollmentComponent,
        data: { permissions: ['ENROLLMENTS_CREATE'] }
      },
      {
        path: 'enrollments/view/:id',
        component: ViewEnrollmentComponent,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'enrollments/view-v2/:id',
        component: ViewEnrollmentV2Component,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'enrollments/corporate/view/:id',
        component: ViewCorporateEnrollmentComponent,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'enrollments/corporate/view-v2/:id',
        component: ViewCorporateEnrollmentV2Component,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'enrollments/view/:id/edit-payment-plans',
        component: EditPaymentPlansComponent,
        data: { permissions: ['ENROLLMENTS_PAYMENT_PLANS'] }
      },
      {
        path: 'enrollments/corporate/edit-company/:agreementId',
        component: EditCorporateCompanyPlansComponent,
        data: { permissions: ['ENROLLMENTS_PAYMENT_PLANS'] }
      },
      {
        path: 'enrollments/corporate/edit-participant/:agreementId/:participantId',
        component: EditCorporateParticipantPlansComponent,
        data: { permissions: ['ENROLLMENTS_PAYMENT_PLANS'] }
      },
      {
        path: 'admin/enrollment-audit',
        component: EnrollmentStatusAuditComponent,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'admin/enrollment-audit/bulk-fix/:batchId',
        component: EnrollmentAuditBulkFixComponent,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },
      {
        // 🆕 Página de progreso del borrado en cascada de proyecto (rol ProjectDeleter validado por la API)
        path: 'admin/project-deletion/:batchId',
        component: ProjectDeletionProgressComponent
      },
      {
        // 🆕 Dashboard de auditoría de planes de pago
        path: 'admin/payment-plan-audit',
        component: PaymentPlanAuditComponent,
        data: { permissions: ['ENROLLMENTS_PAYMENT_PLANS'] }
      },
      {
        // 🆕 Página dedicada de bulk fix masivo
        path: 'admin/payment-plan-audit/bulk-fix/:batchId',
        component: PaymentPlanAuditBulkFixComponent,
        data: { permissions: ['ENROLLMENTS_PAYMENT_PLAN_ADMIN_OPS'] }
      },
      {
        path: 'enrollments/corporate/add-participants/:agreementId',
        component: AddCorporateParticipantsComponent,
        data: { permissions: ['ENROLLMENTS_CREATE'] }
      },

      // === LISTADO DE MOVIMIENTOS DE CARTERA ===
      {
        path: 'enrollments/portfolio-movements/individual',
        component: PortfolioMovementsListComponent,
        data: { view: 'individual', permissions: ['ENROLLMENTS_READ'] }
      },
      {
        path: 'enrollments/portfolio-movements/corporate',
        component: PortfolioMovementsListComponent,
        data: { view: 'corporate', permissions: ['ENROLLMENTS_READ'] }
      },

      // === GESTIÓN DE CARTERA (RETIROS/REVERSIONES/APLAZAMIENTOS) ===
      {
        path: 'enrollments/withdrawal-wizard',
        component: WithdrawalWizardComponent,
        data: { permissions: ['ENROLLMENTS_WITHDRAW'] }
      },
      {
        path: 'enrollments/reversal-wizard',
        component: ReversalWizardComponent,
        data: { permissions: ['ENROLLMENTS_REVERSAL'] }
      },
      {
        path: 'enrollments/deferral-wizard',
        component: DeferralWizardComponent,
        data: { permissions: ['ENROLLMENTS_DEFER'] }
      },

      // === GESTIÓN DE CARTERA CORPORATIVA ===
      {
        path: 'enrollments/corporate-withdrawal-wizard',
        component: CorporateWithdrawalWizardComponent,
        data: { permissions: ['CORPORATE_ENROLLMENTS_WITHDRAW'] }
      },
      {
        path: 'enrollments/corporate-reversal-wizard',
        component: CorporateReversalWizardComponent,
        data: { permissions: ['CORPORATE_ENROLLMENTS_REVERSAL'] }
      },
      {
        path: 'enrollments/corporate-deferral-wizard',
        component: CorporateDeferralWizardComponent,
        data: { permissions: ['CORPORATE_ENROLLMENTS_DEFER'] }
      },

      // === CESIONES DE CUPO ===
      {
        path: 'enrollment-transfers',
        component: EnrollmentTransfersComponent,
        data: { permissions: ['ENROLLMENT_TRANSFERS_READ'] }
      },
      {
        path: 'enrollment-transfers/new',
        component: NewTransferComponent,
        data: { permissions: ['ENROLLMENT_TRANSFERS_CREATE'] }
      },

      // === EMPRESAS ===
      {
        path: 'companies',
        component: CompaniesComponent,
        data: { permissions: ['COMPANIES_READ'] }
      },
      {
        path: 'companies/new',
        component: NewCompanyComponent,
        data: { permissions: ['COMPANIES_CREATE'] }
      },
      {
        path: 'companies/profile/:id',
        component: ProfileCompanyComponent,
        data: { permissions: ['COMPANIES_READ'] }
      },
      {
        path: 'companies/view/:id',
        component: NewCompanyComponent,
        data: { permissions: ['COMPANIES_READ'] }
      },

      // === CONFIGURACIÓN - HUB PRINCIPAL ===
      {
        path: 'config',
        component: ConfigHubComponent,
        data: { permissions: ['CONFIG_BUDGETS_READ', 'CONFIG_BANKS_READ', 'CONFIG_PAYMENT_METHODS_READ'] }
      },

      // === CONFIGURACIÓN - REPORTES CARGADOS ===
      {
        path: 'config/uploaded-reports',
        component: UploadedReportsComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === CONFIGURACIÓN - LOGS DE CONCILIACIÓN ===
      {
        path: 'config/conciliation-logs',
        component: ConciliationLogsComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'config/conciliation-logs/:id',
        component: ConciliationLogDetailComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === CONFIGURACIÓN - PRESUPUESTOS ===
      {
        path: 'config/budgets',
        component: ConfigBudgetsComponent,
        data: { permissions: ['CONFIG_BUDGETS_READ'] }
      },

      // === CONFIGURACIÓN - BANCOS ===
      {
        path: 'config/banks',
        component: BanksComponent,
        data: { permissions: ['CONFIG_BANKS_READ'] }
      },
      {
        path: 'config/banks/new',
        component: NewBankComponent,
        data: { permissions: ['CONFIG_BANKS_CREATE'] }
      },
      {
        path: 'config/banks/edit/:id',
        component: NewBankComponent,
        data: { permissions: ['CONFIG_BANKS_UPDATE'] }
      },

      // === CONFIGURACIÓN - APROBADORES ===
      {
        path: 'config/approvers',
        component: ApproversComponent,
        canActivate: [SuperAdminGuard],
        data: { permissions: ['CONFIG_APPROVERS_READ'] }
      },

      // === CONFIGURACIÓN - SISTEMA ===
      {
        path: 'config/system-reset',
        component: SystemResetComponent,
        data: { permissions: ['CONFIG_SYSTEM_RESET'] }
      },

      // === CONFIGURACIÓN - MÉTODOS DE PAGO ===
      {
        path: 'config/payment-methods',
        component: PaymentMethodsComponent,
        data: { permissions: ['CONFIG_PAYMENT_METHODS_READ'] }
      },
      {
        path: 'config/payment-methods/new',
        component: NewPaymentMethodComponent,
        data: { permissions: ['CONFIG_PAYMENT_METHODS_CREATE'] }
      },
      {
        path: 'config/payment-methods/edit/:id',
        component: NewPaymentMethodComponent,
        data: { permissions: ['CONFIG_PAYMENT_METHODS_UPDATE'] }
      },

      // === CONFIGURACIÓN - TASAS DE CAMBIO ===
      {
        path: 'config/exchange-rate',
        component: ExchangeRateConfigComponent,
        data: { permissions: ['CONFIG_EXCHANGE_READ'] }
      },
      {
        path: 'config/exchange-rate/history',
        component: ExchangeRateHistoryComponent,
        data: { permissions: ['CONFIG_EXCHANGE_HISTORY'] }
      },

      // === CONFIGURACIÓN - TIPOS DE COMISIÓN ===
      {
        path: 'config/fee-types',
        component: FeeTypesComponent,
        data: { permissions: ['CONFIG_FEE_TYPES_READ'] }
      },
      {
        path: 'config/fee-types/new',
        component: NewFeeTypeComponent,
        data: { permissions: ['CONFIG_FEE_TYPES_CREATE'] }
      },
      {
        path: 'config/fee-types/edit/:id',
        component: NewFeeTypeComponent,
        data: { permissions: ['CONFIG_FEE_TYPES_UPDATE'] }
      },

      // === CONFIGURACIÓN - AUDITORÍA ===
      {
        path: 'config/audit-logs',
        component: AuditLogsComponent,
        data: { permissions: ['CONFIG_AUDIT_READ'] }
      },

      // === CONFIGURACIÓN - RASTREO DE EMAILS ===
      {
        path: 'config/email-logs',
        component: EmailLogsComponent,
        data: { permissions: ['CONFIG_EMAILLOG_READ'] }
      },

      // === CONFIGURACIÓN - WOMPI RELAY ===
      {
        path: 'config/wompi-relay',
        component: WompiRelayListComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'config/wompi-relay/new',
        component: NewWompiRelayComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'config/wompi-relay/edit/:id',
        component: NewWompiRelayComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'config/wompi-relay/:id/logs',
        component: WompiRelayLogsComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === INTEGRACIONES - BITRIX ===
      {
        path: 'bitrix-requests',
        component: BitrixRequestsComponent,
        data: { permissions: ['INTEGRATIONS_BITRIX_READ'] }
      },
      {
        path: 'bitrix-requests/:id',
        component: ViewBitrixRequestComponent,
        data: { permissions: ['INTEGRATIONS_BITRIX_READ'] }
      },

      // === INTEGRACIONES - WOMPI ===
      {
        path: 'wompi-requests',
        component: WompiRequestsComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'wompi-requests/:id',
        component: ViewWompiRequestComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === CARGA DE REPORTES WOMPI/PLINK ===
      {
        path: 'report-upload',
        component: ReportUploadComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === CONFIGURACIÓN DE CONCILIACIÓN ===
      {
        path: 'config/conciliation',
        component: ConciliationConfigComponent,
        data: { permissions: ['CONFIG_EXCHANGE_WRITE'] }
      },

      // === REPORTES ===
      {
        path: 'reports',
        component: ReportsHubComponent,
        data: { permissions: ['REPORTS_BASIC', 'REPORTS_FINANCIAL'] }
      },
      {
        path: 'reports/banks',
        component: BanksReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'REPORTS_FINANCIAL'] }
      },
      {
        path: 'reports/income-receipts',
        component: IncomeReceiptsReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'REPORTS_FINANCIAL'] }
      },
      {
        path: 'reports/expense-receipts',
        component: ExpenseReceiptsReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'REPORTS_FINANCIAL'] }
      },
      {
        path: 'reports/project-budget-execution',
        component: ProjectBudgetExecutionReportsComponent,
        data: { permissions: ['REPORTS_FINANCIAL', 'REPORTS_EXECUTIVE'] }
      },
      {
        path: 'reports/work-orders',
        component: WorkOrdersReportsComponent,
        data: { permissions: ['REPORTS_BASIC'] }
      },
      {
        path: 'reports/project-enrollments',
        component: ProjectEnrollmentsReportsComponent,
        data: { permissions: ['REPORTS_BASIC'] }
      },
      {
        path: 'reports/project-program-detail',
        component: ProjectProgramDetailReportsComponent,
        data: { permissions: ['REPORTS_BASIC'] }
      },
      {
        path: 'reports/portfolio',
        component: PortfolioReportsComponent,
        data: { permissions: ['REPORTS_PORTFOLIO'] }
      },
      {
        path: 'reports/created-projects',
        component: CreatedProjectsReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'PROJECTS_READ'] }
      },
      {
        path: 'reports/project-financial-statement',
        component: ProjectFinancialStatementReportsComponent,
        data: { permissions: ['REPORTS_FINANCIAL', 'PROJECTS_READ'] }
      },
      {
        path: 'reports/registered-data',
        component: RegisteredDataReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'PARTICIPANTS_READ'] }
      },
      {
        path: 'reports/participants-by-incp',
        component: ParticipantsByIncpReportsComponent,
        data: { permissions: ['REPORTS_BASIC', 'ENROLLMENTS_READ'] }
      },
      {
        path: 'reports/punished-portfolio',
        component: PunishedPortfolioReportComponent,
        data: { permissions: ['REPORTS_PUNISHED_PORTFOLIO'] }
      },
      {
        path: 'reports/wompi-consolidated',
        component: WompiConsolidatedReportComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'reports/wompi-payments',
        component: WompiPaymentsReportComponent,
        data: { permissions: ['REPORTS_BASIC'] }
      },
      {
        path: 'reports/payment-links-audit',
        component: PaymentLinksAuditReportComponent,
        data: { permissions: ['REPORTS_BASIC'] }
      },
      {
        path: 'enrollments/payment-plans/history/:id',
        component: PaymentPlanHistoryComponent,
        data: { permissions: ['ENROLLMENTS_READ'] }
      },

      // === DEVOLUCIONES ===
      {
        path: 'refund-vouchers',
        component: RefundVouchersComponent,
        data: { permissions: ['REFUNDS_READ'] }
      },
      {
        path: 'refund-vouchers/new',
        component: NewRefundComponent,
        data: { permissions: ['REFUNDS_CREATE'] }
      },
      {
        path: 'refund-vouchers/view/:id',
        component: ViewRefundVoucherComponent,
        data: { permissions: ['REFUNDS_READ'] }
      },

      // === EXCEDENTES ===
      {
        path: 'excess-payments',
        component: ExcessPaymentsComponent,
        data: { permissions: ['EXCESS_READ'] }
      },
      {
        path: 'excess-payments/:id',
        component: ViewExcessPaymentComponent,
        data: { permissions: ['EXCESS_READ'] }
      },

      // === LINKS DE PAGO ===
      {
        path: 'payment-links',
        component: PaymentLinksComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },
      {
        path: 'payment-links/:id',
        component: ViewPaymentLinkComponent,
        data: { permissions: ['INTEGRATIONS_WOMPI_READ'] }
      },

      // === CONCILIACIONES BANCARIAS ===
      {
        path: 'bank-reconciliation',
        component: BankReconciliationListComponent,
        data: { permissions: ['RECONCILIATION_READ'] }
      },
      {
        path: 'closed-bank-periods',
        component: ClosedPeriodsListComponent,
        data: { permissions: ['RECONCILIATION_READ'] }
      },
      {
        path: 'bank-reconciliation/new',
        component: NewBankReconciliationComponent,
        data: { permissions: ['RECONCILIATION_CREATE'] }
      },
      {
        path: 'bank-reconciliation/:id',
        component: NewBankReconciliationComponent,
        data: { permissions: ['RECONCILIATION_READ'] }
      },

      // === TESORERÍA - RECORDATORIOS MANUALES DE PAGO ===
      {
        path: 'treasury/manual-reminders',
        loadChildren: () =>
          import('./components/treasury/manual-reminders/manual-reminders.module')
            .then(m => m.ManualRemindersModule),
        data: { permissions: ['PAYMENT_REMINDERS_SEND_MANUAL'] }
      },

      // === PERFIL (acceso para todos) ===
      {
        path: 'profile',
        component: ProfileComponent,
        data: { permissions: ['PROFILE_READ'] }
      },

      // === GESTIÓN DE ROLES Y PERMISOS (Solo SuperAdmin) ===
      {
        path: 'config/roles',
        component: RolesListComponent,
        canActivate: [SuperAdminGuard],
        data: { permissions: ['CONFIG_ROLES_READ'] }
      },
      {
        path: 'config/roles/new',
        component: RoleFormComponent,
        canActivate: [SuperAdminGuard],
        data: { permissions: ['CONFIG_ROLES_CREATE'] }
      },
      {
        path: 'config/roles/:id',
        component: RoleFormComponent,
        canActivate: [SuperAdminGuard],
        data: { permissions: ['CONFIG_ROLES_UPDATE'] }
      },
      {
        path: 'config/users',
        component: UsersListComponent,
        canActivate: [SuperAdminGuard],
        data: { permissions: ['CONFIG_ROLES_USER_ROLES'] }
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
